module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtxth"
  }, [_vm._v("PRAISE FOR DESTINY SORIA’S")]), _vm._v(" "), _c('p', {
    staticClass: "fmtxth1"
  }, [_c('strong', [_c('em', [_vm._v("IRON CAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Images",
      "src": "images/star.jpg"
    }
  }), _vm._v(" “Energetic and original, this alternative history, fantasy, and mystery mashup with its pair of smart, resourceful, flawed but engaging heroines never disappoints.”"), _c('br'), _vm._v("—"), _c('em', [_vm._v("Kirkus Reviews")]), _vm._v(", starred review")]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Images",
      "src": "images/star.jpg"
    }
  }), _vm._v(" “Hand this entrancing historical fantasy to fans of Libba Bray’s Diviners series or anyone who likes their magic on the seamier side.”"), _c('br'), _vm._v("—"), _c('em', [_vm._v("Booklist")]), _vm._v(", starred review")]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Images",
      "src": "images/star.jpg"
    }
  }), _vm._v(" “Stories of the diverse cast of flawed and complicated characters striving to do better complement the solid female friendship at the core of this absorbing novel . . . Mystery and fantasy blend well in this witty title filled with twists and fast-paced action.”"), _c('br'), _vm._v("—"), _c('em', [_vm._v("School Library Journal")]), _vm._v(", starred review")]), _vm._v(" "), _c('p', {
    staticClass: "fmtxt"
  }, [_vm._v("“Destiny Soria’s debut is without a doubt one of the best of the year.”"), _c('br'), _vm._v("—"), _c('em', [_vm._v("YA Books Central")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0f88da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 57
// module chunks = 0